import { AlertTriangle } from 'lucide-react';
import toast from 'react-hot-toast';
import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/ui/design-system/components/ui/alert-dialog';
import { Button } from '@/ui/design-system/components/ui/button';
import { useRevokeApiKey } from 'utils/hooks/apiKeys';

function RevokeKeyDialog({ open, onOpenChange, apiKey }) {
    const revokeKey = useRevokeApiKey();

    const handleRevoke = async () => {
        try {
            await revokeKey.mutateAsync(apiKey.id);
            toast.success('API key revoked', {
                icon: '✅',
                position: 'top-right',
            });
            onOpenChange(false);
        } catch {
            toast.error('Failed to revoke API key');
        }
    };

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <div className="flex items-center gap-3">
                        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
                            <AlertTriangle className="h-5 w-5 text-red-600" />
                        </div>
                        <AlertDialogTitle>Revoke API Key</AlertDialogTitle>
                    </div>
                    <AlertDialogDescription className="pt-2">
                        Are you sure you want to revoke the key{' '}
                        <strong>&ldquo;{apiKey?.name}&rdquo;</strong>?
                    </AlertDialogDescription>
                    <p className="text-sm text-muted-foreground">
                        Any applications using this key will immediately stop
                        working. This action cannot be undone.
                    </p>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>Cancel</AlertDialogCancel>
                    <Button
                        variant="destructive"
                        disabled={revokeKey.isLoading}
                        onClick={handleRevoke}
                    >
                        {revokeKey.isLoading ? 'Revoking...' : 'Revoke Key'}
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}

export default RevokeKeyDialog;
